import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const mexicanCities = ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Toluca', 'Tijuana', 'León', 'Juárez', 'Zapopan', 'Mérida', 'Querétaro', 'San Luis Potosí', 'Aguascalientes', 'Hermosillo'];
const mexicanNames = ['Ximena Hernández', 'Alejandro Ruiz', 'Mariana Flores', 'Diego Morales', 'Fernanda Ortiz', 'Ricardo Jiménez', 'Sofía Vázquez', 'Javier Mendoza', 'Camila Reyes', 'Gabriel Salazar', 'Valeria Ramos', 'Daniel Espinoza', 'Andrea Castro', 'Mateo Luna', 'Isabella Bravo', 'Sebastián Nava'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = mexicanNames[Math.floor(Math.random() * mexicanNames.length)];
      const randomCity = mexicanCities[Math.floor(Math.random() * mexicanCities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialDelay = setTimeout(showPopup, 15000);
    const interval = setInterval(showPopup, 90000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-3 left-3 md:bottom-4 md:left-4 z-50 animate-slide-in" data-id="element-356">
      <div className="bg-[#121212] rounded-lg shadow-[0_0_15px_rgba(156,22,163,0.3)] p-2.5 md:p-3 max-w-[260px] md:max-w-xs border border-[#9C16A3]/50" data-id="element-357">
        <div className="flex items-start gap-2" data-id="element-358">
          <div className="bg-[#9C16A3]/20 rounded-full p-1 md:p-1.5 flex-shrink-0" data-id="element-359">
            <ShoppingBagIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#FC9DFF]" data-id="element-360" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-361">
            <p className="font-bold text-white text-[10px] md:text-xs" data-id="element-362">
              ¡Compra reciente!
            </p>
            <p className="text-gray-300 text-[10px] md:text-xs" data-id="element-363">
              <span className="font-semibold text-white" data-id="element-364">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city} compró{' '}
              <span className="font-semibold text-[#FC9DFF]" data-id="element-365">
                Luxury Brow Extensions
              </span>
            </p>
            <p className="text-gray-500 text-[9px] md:text-[10px] mt-0.5" data-id="element-366">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-500 hover:text-[#FC9DFF] transition-colors flex-shrink-0" data-id="element-367">
            <XIcon className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-368" />
          </button>
        </div>
      </div>
    </div>;
}